<!--
 * @Desc: 学校概况
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-06 13:49:51
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-school-profile">
        <!-- 菜单 -->
        <menuCommon :active="active"></menuCommon>
        <!-- 内容区 -->
        <!-- 内容区 -->
        <BreadCrumb :objectData="objectData"></BreadCrumb>
        <section class="profile-school">
            <div class="container">
                <div class="profile-list">
                    <el-empty description="暂无数据" v-if="tableData && tableData.length == 0"></el-empty>
                    <div class="profile-item" @click="toDetail(item)" v-for="(item,idx) in tableData" :key="item.id">
                        <div class="item-info">
                            <!-- <div class="item-tag">领导关怀</div> -->
                            <div class="item-title ellipsis1">
                                {{ item.title }}
                            </div>
                            <div class="item-desc ellipsis2">
                                {{ item.keywords }}
                            </div>
                            <div v-if="item.publish_at" class="item-time">
                                {{ timestampToTime(item.publish_at,1) }}
                            </div>
                            <div v-if="item.source" class="item-adress ellipsis1">
                                {{ item.source }}
                            </div>
                            <div class="divider"></div>
                            <div data-v-0c294a10="" class="more">
                                了解更多
                                <img
                                    class="arr"
                                    src="../../public/statics/images/arr.png"
                                />
                            </div>
                        </div>
                        <div class="item-thu">
                            <img
                                class="thu"
                                :src="$adddom(item.thumb)"
                            />
                        </div>
                    </div>
                </div>
                <div class="pagination" v-if="queryParam.total>0">
                    <el-pagination
                        background
                        @current-change="handleQueryEvent"
                        :current-page.sync="queryParam.page"
                        :page-size="queryParam.size"
                        layout="prev, pager, next, jumper"
                        :total="queryParam.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </section>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
    </div>
</template>

<script>
import utils from "@/api/Utils.js"
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
export default {
    name: "home",
    data() {
        return {
            // 菜单选中
            active: this.$route.query.active,
            // 栏目详情
            cateData:'',
            // 面包屑展示数据
            objectData: {
                title: "",
                navArray: [
                ],
                thu:''
            },
            queryParam: {
                cate_id: "",
                total: 0,
                page: 1,
                size: 10,
            },
            tableData:''
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
    },
    created() {
        this.cateDetail()
        this.searchClick()
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        // 格式化时间
        timestampToTime(timestamp, type){
            return utils.timestampToTime(timestamp, type)
        },
        // 栏目详情 面包屑展示
        cateDetail(){
            let that = this
            that.$api.index.cateDetail({id:this.$route.query.active}).then((res) => {
                if (res.code == 200) {
                    that.cateData = res.result
                    that.objectData.title = that.cateData.name
                    that.objectData.navArray = that.cateData.breadcrumb
                    that.objectData.thu = that.cateData.thumb
                }
            })
        },
        /**
         * @name: 跳转详情
         * @param {*} item
         * @return {*}
         * @desc: 跳转详情
         */        
        toDetail(item){
            // console.log(item)
            this.$toPath('/NewsDetail?active='+this.active+'&id=' +item.id)
        },
        /**
         * @name: 搜索
         * @return {*}
         * @desc: 
         */        
        searchClick() {
            this.queryParam.page = 1;
            this.handleQueryEvent();
        },
        /**
         * @name: 调用接口 查询数据
         * @return {*}
         * @desc: 
         */        
        handleQueryEvent() {
            // 调用接口
            console.log("调用接口");
            let that = this
            this.queryParam.cate_id = this.$route.query.active
            that.$api.index.articleList(this.queryParam).then((res) => {
                if (res.code == 200) {
                    console.log(res)
                    that.tableData = res.result.list
                    that.queryParam.total = res.result.total
                }
            })
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-school-profile {
    background: #f0f2f5;
}
.page-school-profile .profile-school {
    padding-top: 50px;
}
.page-school-profile .pagination {
    text-align: center;
    margin: 60px 0;
}
.page-school-profile
    /deep/
    .el-pagination.is-background
    .el-pager
    li:not(.disabled).active {
    background: #e22f24;
}
.page-school-profile .profile-school .container .profile-list {
}
.page-school-profile .profile-list .profile-item {
    margin-bottom: 70px;
    padding-top: 47px;
    position: relative;
    height: 497px;
}
.page-school-profile .profile-list .profile-item:last-child {
    margin-bottom: 0;
}
.page-school-profile .profile-list .profile-item .item-info {
    width: 1026px;
    height: 450px;
    background: url(../../public/statics/images/SchoolProfile/profile-bg.png) #012241;
    padding: 106px 492px 60px 53px;
}
.page-school-profile .profile-list .profile-item .item-info .item-tag {
    display: inline-block;
    background-color: rgba(226, 47, 36, 1);
    overflow-wrap: break-word;
    color: rgba(243, 240, 236, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    line-height: 24px;
    padding: 0 6px;
    margin-bottom: 8px;
}
.page-school-profile .profile-list .profile-item .item-info .item-title {
    font-size: 30px;
    font-family: AppleSystemUIFont;
    color: #ffffff;
}
.page-school-profile .profile-list .profile-item .item-info .item-desc {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 28px;
    color: rgba(198, 216, 233, 1);
    text-align: left;
    vertical-align: top;
    height: 56px;
    margin-top: 10px;
    margin-bottom: 30px;
}
.page-school-profile .profile-list .profile-item .item-info .item-time {
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    padding-left: 24px;
    position: relative;
}

.page-school-profile .profile-list .profile-item .item-time::after{
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 11px;
    height: 11px;
    background: url(../../public/statics/images/SchoolProfile/icon-time-circle.png);
}
.page-school-profile .profile-list .profile-item .item-info .item-adress {
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
    padding-left: 24px;
    position: relative;
    margin: 5px 0;
}
.page-school-profile .profile-list .profile-item .item-adress::after{
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 10px;
    height: 12px;
    background: url(../../public/statics/images/SchoolProfile/icon-location.png);
}
.page-school-profile .profile-list .profile-item .item-info .divider {
    width: 482px;
    height: 2px;
    background: #e22f24;
    margin-top: 10px;
}
.page-school-profile .profile-list .profile-item .item-info .more {
    overflow-wrap: break-word;
    color: #fff;
    font-size: 14px;
    font-family: PingFangSC;
    text-align: left;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    cursor: pointer;
}
.page-school-profile .profile-list .profile-item .item-info .more .arr {
    width: 18px;
    height: 13px;
}
.page-school-profile .profile-list .profile-item .item-thu {
    position: absolute;
    right: 0;
    top: 0px;
    width: 618px;
    height: 397px;
}
.page-school-profile .profile-list .profile-item .item-thu .thu {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>